module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei1.svg";